import "./balance.css"
import {usePumpStore} from "../../store/pumpStore";
import React, {useEffect} from "react";
import axios from "axios";
import {Locales} from "../../helpers/localeHelpers";
import parse from "html-react-parser";


export const Balance = () => {
    const {history, setHistory, appInitData, language} = usePumpStore()


    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function dynamicSort(property) {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            /* next line works with strings and numbers,
             * and you may want to customize it to your needs
             */
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }

    useEffect(() => {
        axios.post('https://pump.stt.market/api/history', {'chat_id': appInitData.user.id}).then((res) => {
            const data = res.data
            const rows = data.sort(dynamicSort('-time'))
            setHistory(rows)
        })
    }, []);

    return (
        <div className={"history"}>
            <h4 className={"block-title"}>{parse(Locales[language].history)}</h4>
            {history.map((item, index) => (
                <div className={"history__row"} key={index}>
                    <div className={`history__row-amount ${item.amount > 0 && '_income'} ${item.amount < 0 && '_loss'}`}>{numberWithCommas(item.amount.toFixed(2))}</div>
                    <div className={"history__row-type"}>{item.type}</div>
                    <div className={"history__row-time"}>{item.time}</div>
                </div>
            ))}
        </div>
    )
}